import { render, staticRenderFns } from "./GraphicDetails.vue?vue&type=template&id=61e3c30c&scoped=true"
import script from "./GraphicDetails.vue?vue&type=script&lang=js"
export * from "./GraphicDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e3c30c",
  null
  
)

export default component.exports